import { convert_name_UNICODE } from '../../utils/conversion'

export function AccountCreateDTO(payload) {
  if (!payload) {
    return null
  }

  // Kiểm tra payload có phải là mảng hay object
  const isArrayPayload = Array.isArray(payload)

  return {
    uuid: payload.uuid,
    id: String(isArrayPayload ? payload[0] : payload.id || ''), // string
    name: convert_name_UNICODE(
      String(isArrayPayload ? payload[1] : payload.name || '')
    ), // string
    course: Number(isArrayPayload ? payload[2] : payload.course || 0), // number
    groups: isArrayPayload
      ? Array.isArray(payload[3])
        ? payload[3].map((group) => String(group).toUpperCase())
        : typeof payload[3] === 'string'
          ? [String(payload[3]).toUpperCase()]
          : []
      : Array.isArray(payload.groups)
        ? payload.groups.map((group) => String(group).toUpperCase())
        : [], // array of strings
    schoolEmail: String(
      isArrayPayload ? payload[4] : payload.schoolEmail || ''
    ).trim(), // string
    personalEmail: String(
      isArrayPayload ? payload[5] : payload.personalEmail || ''
    ).trim(), // string
    phoneNumber: String(
      isArrayPayload ? payload[6] : payload.phoneNumber || ''
    ), // string
    className: String(isArrayPayload ? payload[7] : payload.className || ''), // string
    faculty: String(isArrayPayload ? payload[8] : payload.faculty || ''), // string
    school: String(isArrayPayload ? payload[9] : payload.school || ''), // string
    devices: (isArrayPayload ? payload[10] : payload.devices) ?? [], // array of strings
    books: (isArrayPayload ? payload[11] : payload.books) ?? [], // array of strings
  }
}

export function AccountGetDTO(payload) {
  if (!payload) {
    return null
  }

  return {
    id: String(payload.id || ''), // string
    name: convert_name_UNICODE(String(payload.name || '')), // string
    course: Number(payload.course || 0), // number
    groups: Array.isArray(payload.groups)
      ? payload.groups.map((group) => String(group).toUpperCase())
      : [], // array of strings
    schoolEmail: String(payload.schoolEmail || ''), // string
    personalEmail: String(payload.personalEmail || ''), // string
    phoneNumber: String(payload.phoneNumber || ''), // string
    className: String(payload.className || ''), // string
    faculty: String(payload.faculty || ''), // string
    school: String(payload.school || ''), // string
    devices: payload.devices ?? [], // array of strings
    books: payload.books ?? [], // array of strings
  }
}
